import { BankingPanel } from "@/features/banking/components/banking-panel";
import { useActiveClient } from "@/layouts/client-layout";

export default function BankingPage() {
  const { client } = useActiveClient();
  return <BankingPanel clientId={client.id} />;
}
